import UIStrings from '@/Utils/UIStrings';

interface DialogCardRejectBodyProps {
    name: string;
}

function DialogCardRejectBody({ name }: DialogCardRejectBodyProps) {
    return (
        <div className="text-foreground text-sm font-normal">
            <span>{`${UIStrings.RejectApplicantDialogBody1} `}</span>
            <span>{`${UIStrings.RejectApplicantDialogBody2} ${name} ${UIStrings.RejectApplicantDialogBody3}`}</span>
        </div>
    );
}
export default DialogCardRejectBody;
